import http from './http';

/**
 * Busca turnos disponibles. pacienteId es obligatorio (el backend lo usa para
 * calcular la cobertura y el costo). Los demás filtros son opcionales.
 *
 * Respuesta: { turnos: [...], paginacion: { page, pageSize, totalTurnos, totalPaginas } }
 * Cada turno: { id, medico:{id,nombre}, servicio:{nombre,tipo}, sede, fechaYHora, tipoCobertura, costoEstimado }
 */
export async function buscarTurnos({ pacienteId, ...filtros }) {
  const { data } = await http.get('/turnos', {
    params: { pacienteId, ...filtros },
  });
  return data;
}

/** Reserva un turno (espacio en agenda) para un paciente. */
export async function reservarTurno(pacienteId, turnoId) {
  const { data } = await http.post(`/pacientes/${pacienteId}/turnos/${turnoId}`);
  return data;
}

/** Historial completo de turnos del paciente (próximos + pasados). */
export async function obtenerTurnosDeUsuario(pacienteId) {
  const { data } = await http.get(`/pacientes/${pacienteId}/turnos`);
  return data; // [{ id, fechaYHora, estado, medico, sede }]
}

/** Cancela un turno futuro del paciente. El backend enruta por el body { motivo }. */
export async function cancelarTurno(pacienteId, turnoId, motivo = 'Cancelado por el paciente') {
  const { data } = await http.patch(`/pacientes/${pacienteId}/turnos/${turnoId}`, { motivo });
  return data;
}
